import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, ShieldCheck, Truck, Heart, Star, Plus, ShoppingCart, Check, ChevronLeft, ChevronRight } from 'lucide-react';
import { useCart } from '../context/CartContext';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PRODUCT_IMAGES = {
  promescent: 'https://www.promescent.com/cdn/shop/files/20Spray_1024x1024_da9bd637-8d47-4570-86e5-d4a698f59e90.webp?v=1738251213',
  back2game: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/m1ozw06h_%2B%20%281%29.png',
  titan: 'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/uhp34fvx_4.png',
  vitamel: 'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/o2gggziq_3.png',
};

const HOME_REVIEWS = [
  { name: 'קונסטנטין מ.', product: 'תרסיס עיכוב', image: PRODUCT_IMAGES.promescent, review: 'אני משתמש במוצר הזה כבר כ-3 שנים ואני יכול לומר בכנות שהמוצר עצמו ממש טוב. הוא תמיד עבד מצוין בשבילי, מה שנותן ביטחון אמיתי.', rating: 5 },
  { name: 'קווין ב.', product: "ג'ל עוררות", image: PRODUCT_IMAGES.titan, review: 'אני משתמש במוצר הזה כבר בערך שנה. קניתי אותו משום מקום, ואני רוצה לספר לכם איזו מציאה. אשתי נהנתה ממנו מאוד מאוד.', rating: 5 },
  { name: 'אהרון ס.', product: 'תרסיס עיכוב', image: PRODUCT_IMAGES.promescent, review: 'מרחתי את זה לפי ההוראות ו-וואה. לקחת את זה אינטנו לחופשה בשבע שעבר ולא אמרו לנו לאשרי לפני כן.', rating: 5 },
  { name: "קווין ג'.", product: 'ויטמל', image: PRODUCT_IMAGES.vitamel, review: 'התחלתי להשתמש במוצר הזה אחרי שהאורולוג שלי המליץ עליו. אני מרגיש צעיר ב-20 שנה ונהנה ממנו הרבה.', rating: 5 },
  { name: 'יוסי כ.', product: 'Back 2 Game', image: PRODUCT_IMAGES.back2game, review: 'מוצר מדהים! הרגשתי שיפור משמעותי כבר אחרי שבועיים של שימוש. ממליץ בחום לכל מי שמחפש פתרון אמיתי.', rating: 5 },
  { name: 'אבי מ.', product: 'תרסיס עיכוב', image: PRODUCT_IMAGES.promescent, review: 'הזמנתי בספקנות אבל התוצאות מדברות בעד עצמן. האנרגיה שלי עלתה והביטחון חזר.', rating: 5 },
  { name: 'דני ל.', product: "ג'ל עוררות", image: PRODUCT_IMAGES.titan, review: 'אחרי שניסיתי הרבה מוצרים, סוף סוף מצאתי משהו שעובד באמת. תודה רבה!', rating: 5 },
  { name: 'משה ר.', product: 'Back 2 Game', image: PRODUCT_IMAGES.back2game, review: 'המוצר הגיע מהר ובאריזה דיסקרטית. התוצאות פשוט מעולות, ממליץ לכולם.', rating: 5 },
  { name: 'רון ש.', product: 'ויטמל', image: PRODUCT_IMAGES.vitamel, review: 'בן 52 וחשבתי שאין מה לעשות. המוצרים החזירו לי את הביטחון העצמי!', rating: 5 },
  { name: 'גיל ב.', product: 'תרסיס עיכוב', image: PRODUCT_IMAGES.promescent, review: 'שימוש יומיומי כבר 3 חודשים. השינוי הוא פשוט מטורף. תודה!', rating: 5 },
  { name: 'רועי ש.', product: 'Back 2 Game', image: PRODUCT_IMAGES.back2game, review: 'מוצר טוב מאוד, לקח כמה ימים עד שהרגשתי את ההשפעה אבל מאז - שיפור ניכר.', rating: 4 },
  { name: 'עומר ג.', product: "ג'ל עוררות", image: PRODUCT_IMAGES.titan, review: 'כבר חודשיים שאני משתמש ומרגיש כמו בן 20 מחדש. תודה רבה!', rating: 5 },
  { name: 'נדב ח.', product: 'תרסיס עיכוב', image: PRODUCT_IMAGES.promescent, review: 'הפעם הראשונה שהזמנתי אונליין והופתעתי לטובה. אריזה דיסקרטית ואיכות מעולה.', rating: 5 },
  { name: 'אריאל ב.', product: 'ויטמל', image: PRODUCT_IMAGES.vitamel, review: 'המבצע של 1+1 היה משתלם מאוד. שני המוצרים הגיעו במצב מושלם.', rating: 5 },
  { name: 'ירון ז.', product: "ג'ל עוררות", image: PRODUCT_IMAGES.titan, review: 'הטיטאן ג\'ל שינה את חווית הזוגיות שלנו. נספג מהר ותחושה מדהימה.', rating: 5 },
];

const playCartSound = () => {
  const audio = new Audio('data:audio/mp3;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU4Ljc2LjEwMAAAAAAAAAAAAAAA//tQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWGluZwAAAA8AAAACAAABhgC7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7//////////////////////////////////////////////////////////////////8AAAAATGF2YzU4LjEzAAAAAAAAAAAAAAAAJAAAAAAAAAAAAYZNLBruAAAAAAD/+1DEAAAGAAGn9AAAIwwKd/OMACQAABpAAAABQGCAIAh8EAQBAH/BAEAQBA4sIAgCAIHc+ZQEAXP/6gIAgCAJnn/pAEPBA1/84CgIAgGOD//lwGBsMsP/nkQGPgg+f+8MYgIJn+MMDAYGBQM8H//+DBg4f//5wcGIBAED///+UGIIgCDoGJgcf////h+c/////BgxiRq7/2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//tQxAADwAABpAAAACAAADSAAAAE//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8=');
  audio.volume = 0.3;
  audio.play().catch(() => {});
};

const Home = () => {
  const [products, setProducts] = useState([]);
  const { addToCart } = useCart();
  const navigate = useNavigate();
  const [addedProducts, setAddedProducts] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [currentReview, setCurrentReview] = useState(0);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const productsRes = await axios.get(`${API}/products`);
        setProducts(productsRes.data.slice(0, 4));
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    
    fetchData();
  }, []);
  
  const handleAddToCart = (e, product) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (addedProducts[product.id]) {
      navigate('/cart');
      return;
    }
    
    addToCart({
      id: product.id,
      name: product.name,
      price: product.price,
      image: product.image,
      description: product.description,
      category: product.category
    });
    
    setAddedProducts(prev => ({ ...prev, [product.id]: true }));
    playCartSound();
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), 2000);
    toast.success('נוסף לסל!');
  };
  
  return (
    <div>
      {/* Cart Popup - slides from top */}
      {showPopup && (
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 bg-green-500 text-white px-8 py-4 rounded-2xl shadow-2xl flex items-center gap-3 animate-slide-down" data-testid="cart-popup">
          <Check className="w-6 h-6" />
          <span className="font-bold text-lg" style={{ fontFamily: 'Heebo, sans-serif' }}>נוסף לסל</span>
        </div>
      )}
      
      {/* Hero Section */}
      <section className="relative py-16 md:py-24 overflow-hidden bg-white" data-testid="hero-section">
        <div className="container relative z-10">
          <div className="grid grid-cols-1 gap-8 items-center">
            <div className="text-right space-y-6 fade-in">
              <h1 className="text-3xl md:text-4xl lg:text-4xl font-bold tracking-tight text-[#2C3E2D]" style={{ fontFamily: 'Heebo, sans-serif' }} data-testid="hero-title">
                <span className="text-[#D97706]">המקום לחיים טובים יותר</span>
              </h1>
              <p className="text-base md:text-lg leading-relaxed text-stone-600">
                מוצרים איכותיים ומידע מקצועי לבריאות הגבר. כל המוצרים שלנו נבחרו בקפידה ועברו ביקורת איכות.
              </p>
              <div className="flex gap-4 justify-end">
                <Link
                  to="/products"
                  data-testid="cta-products-button"
                  className="h-12 px-8 rounded-full bg-[#D97706] text-white font-bold hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 flex items-center gap-2"
                  style={{ fontFamily: 'Heebo, sans-serif' }}
                >
                  צפה במוצרים
                  <ArrowLeft className="w-5 h-5" />
                </Link>
                <Link
                  to="/articles"
                  data-testid="cta-articles-button"
                  className="h-12 px-8 rounded-full border-2 border-[#2C3E2D] text-[#2C3E2D] hover:bg-[#2C3E2D] hover:text-white transition-all duration-300 flex items-center"
                  style={{ fontFamily: 'Heebo, sans-serif' }}
                >
                  מאמרים
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Category Banners */}
      <section className="py-8 md:py-12" data-testid="category-banners-section">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Male Enhancement Banner */}
            <Link 
              to="/products" 
              className="group block relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 aspect-[4/3]"
              data-testid="banner-male-enhancement"
            >
              <img
                src="https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/fvckzyjl_%2B%20%28701%20x%20700%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29%20%28900%20x%20700%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29%20%28901%20x%20700%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29.png"
                alt="חיזוק האון הגברי"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                style={{ objectPosition: 'center 30%' }}
              />
              <div className="absolute inset-x-0 top-0 bg-gradient-to-b from-black/50 to-transparent p-5 md:p-6 pb-16 z-10">
                <h2 className="text-xl md:text-2xl font-black text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]" style={{ fontFamily: 'Heebo, sans-serif' }}>
                  חיזוק האון הגברי
                </h2>
                <p className="text-white/90 mt-1 text-sm flex items-center gap-2 drop-shadow-[0_1px_3px_rgba(0,0,0,0.8)]">
                  לצפייה במוצרים
                  <ArrowLeft className="w-4 h-4 group-hover:-translate-x-2 transition-transform" />
                </p>
              </div>
            </Link>

            {/* Fitness Banner */}
            <Link 
              to="/fitness" 
              className="group block relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 aspect-[4/3]"
              data-testid="banner-fitness"
            >
              <img
                src="https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/6ortevjx_%D7%A2%D7%99%D7%A6%D7%95%D7%91%20%D7%9C%D7%9C%D7%90%20%D7%A9%D7%9D%20%2823%29.png"
                alt="תזונה וכושר"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                style={{ objectPosition: 'center 30%' }}
              />
              <div className="absolute inset-x-0 top-0 bg-gradient-to-b from-black/50 to-transparent p-5 md:p-6 pb-16 z-10">
                <h2 className="text-xl md:text-2xl font-black text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]" style={{ fontFamily: 'Heebo, sans-serif' }}>
                  תזונה וכושר
                </h2>
                <p className="text-white/90 mt-1 text-sm flex items-center gap-2 drop-shadow-[0_1px_3px_rgba(0,0,0,0.8)]">
                  לצפייה במוצרים
                  <ArrowLeft className="w-4 h-4 group-hover:-translate-x-2 transition-transform" />
                </p>
              </div>
            </Link>
          </div>
        </div>
      </section>
      
      {/* Features */}
      <section className="py-16 bg-[#F5F5F4]" data-testid="features-section">
        <div className="container">
          <div className="grid grid-cols-3 gap-3 md:gap-6">
            <div className="bg-white p-4 md:p-8 rounded-2xl flex flex-col items-center text-center gap-2 md:gap-4 hover:shadow-md transition-shadow shadow-sm border border-[#D97706]/20" data-testid="feature-quality">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-[#D97706]/10 rounded-full flex items-center justify-center">
                <ShieldCheck className="w-7 h-7 md:w-8 md:h-8 text-[#D97706]" />
              </div>
              <h3 className="text-sm md:text-xl font-bold" style={{ fontFamily: 'Heebo, sans-serif' }}>
                איכות מובטחת
              </h3>
              <p className="text-stone-600 text-xs md:text-base">
                כל המוצרים עוברים ביקורת איכות מקיפה
              </p>
            </div>
            
            <div className="bg-white p-4 md:p-8 rounded-2xl flex flex-col items-center text-center gap-2 md:gap-4 hover:shadow-md transition-shadow shadow-sm border border-[#D97706]/20" data-testid="feature-shipping">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-[#D97706]/10 rounded-full flex items-center justify-center">
                <Truck className="w-7 h-7 md:w-8 md:h-8 text-[#D97706]" />
              </div>
              <h3 className="text-sm md:text-xl font-bold" style={{ fontFamily: 'Heebo, sans-serif' }}>
                משלוח דיסקרטי
              </h3>
              <p className="text-stone-600 text-xs md:text-base">
                משלוח מהיר לכל רחבי הארץ באריזה נייטרלית
              </p>
            </div>
            
            <div className="bg-white p-4 md:p-8 rounded-2xl flex flex-col items-center text-center gap-2 md:gap-4 hover:shadow-md transition-shadow shadow-sm border border-[#D97706]/20" data-testid="feature-support">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-[#D97706]/10 rounded-full flex items-center justify-center">
                <Heart className="w-7 h-7 md:w-8 md:h-8 text-[#D97706]" />
              </div>
              <h3 className="text-sm md:text-xl font-bold" style={{ fontFamily: 'Heebo, sans-serif' }}>
                תמיכה מקצועית
              </h3>
              <p className="text-stone-600 text-xs md:text-base">
                צוות מומחים עומדת לשירותכם בכל שאלה
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Featured Products */}
      <section className="py-16" data-testid="featured-products-section">
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              מוצרים פופולריים
            </h2>
            <p className="text-base md:text-lg text-stone-600">
              המוצרים המבוקשים ביותר שלנו
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {products.map((product) => (
              <div
                key={product.id}
                data-testid={`product-card-${product.id}`}
                className="group relative bg-white rounded-2xl overflow-hidden border border-stone-100 hover:border-[#D97706]/30 transition-all duration-300 hover:shadow-lg"
              >
                <Link to={`/products/${product.id}`}>
                  <div className="aspect-square overflow-hidden">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-6 pb-2">
                    <h3 className="text-lg font-semibold text-[#2C3E2D] mb-2" style={{ fontFamily: 'Heebo, sans-serif' }}>
                      <bdi>{product.name}</bdi>
                    </h3>
                    <p className="text-stone-600 text-sm mb-4 line-clamp-2">
                      {product.description}
                    </p>
                  </div>
                </Link>
                <div className="px-6 pb-5 flex items-center justify-between">
                  <span className="flex items-baseline gap-2" style={{ fontFamily: 'Heebo, sans-serif' }}>
                    {product.old_price && product.old_price > product.price && (
                      <span className="text-base text-stone-400 line-through">₪{product.old_price.toFixed(0)}</span>
                    )}
                    <span className="text-2xl font-bold text-[#D97706]">₪{product.price.toFixed(2)}</span>
                  </span>
                  <button
                    onClick={(e) => handleAddToCart(e, product)}
                    data-testid={`home-add-to-cart-${product.id}`}
                    className={`flex items-center gap-2 px-4 py-2.5 rounded-full font-bold text-sm transition-all duration-300 ${
                      addedProducts[product.id]
                        ? 'bg-green-500 hover:bg-green-600 text-white'
                        : 'bg-[#D97706] hover:bg-[#B45309] text-white'
                    }`}
                    style={{ fontFamily: 'Heebo, sans-serif' }}
                  >
                    {addedProducts[product.id] ? (
                      <>
                        <Check className="w-4 h-4" />
                        מעבר לרכישה
                      </>
                    ) : (
                      <>
                        <Plus className="w-4 h-4" />
                        הוסף לסל
                      </>
                    )}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      {/* Testimonials Carousel */}
      <section className="py-16 bg-[#F5F5F4]" data-testid="testimonials-section">
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              מה אומרים הלקוחות
            </h2>
          </div>
          
          <div className="relative max-w-2xl mx-auto">
            <button
              onClick={() => setCurrentReview((prev) => (prev - 1 + HOME_REVIEWS.length) % HOME_REVIEWS.length)}
              className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-stone-100 transition-colors"
              data-testid="home-review-prev"
            >
              <ChevronLeft className="w-6 h-6 text-[#2C3E2D]" />
            </button>
            
            <div className="mx-12 bg-white rounded-2xl p-8 border border-stone-200 shadow-sm" data-testid="home-review-card">
              <div className="flex flex-col items-center mb-4">
                <div className="w-24 h-28 mb-3 flex items-center justify-center">
                  <img src={HOME_REVIEWS[currentReview].image} alt={HOME_REVIEWS[currentReview].product} className="max-h-28 max-w-24 object-contain" />
                </div>
                <p className="font-bold text-[#2C3E2D] text-sm mb-2" style={{ fontFamily: 'Heebo, sans-serif' }}>{HOME_REVIEWS[currentReview].product}</p>
                <div className="flex items-center gap-1">
                  {[...Array(HOME_REVIEWS[currentReview].rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-[#D97706] text-[#D97706]" />
                  ))}
                  {[...Array(5 - HOME_REVIEWS[currentReview].rating)].map((_, i) => (
                    <Star key={`e-${i}`} className="w-5 h-5 text-stone-300" />
                  ))}
                </div>
              </div>
              <p className="text-stone-600 text-center mb-4 leading-relaxed min-h-[60px]" style={{ fontFamily: 'Heebo, sans-serif' }}>
                "{HOME_REVIEWS[currentReview].review}"
              </p>
              <div className="flex items-center justify-center gap-3">
                <p className="font-semibold text-[#2C3E2D]" style={{ fontFamily: 'Heebo, sans-serif' }}>
                  {HOME_REVIEWS[currentReview].name}
                </p>
                <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full font-medium">קונה מאומת</span>
              </div>
              <div className="flex justify-center gap-2 mt-4">
                {HOME_REVIEWS.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentReview(index)}
                    className={`w-2 h-2 rounded-full transition-colors ${index === currentReview ? 'bg-[#D97706]' : 'bg-stone-300'}`}
                  />
                ))}
              </div>
            </div>
            
            <button
              onClick={() => setCurrentReview((prev) => (prev + 1) % HOME_REVIEWS.length)}
              className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-stone-100 transition-colors"
              data-testid="home-review-next"
            >
              <ChevronRight className="w-6 h-6 text-[#2C3E2D]" />
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;